export const formatCPF = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2")
    .slice(0, 14);
};

export const validateCPFLength = (cpf: string) => {
  const digits = cpf.replace(/\D/g, "");
  return digits.length === 11;
};

// Só dígitos, com os zeros à esquerda que o Excel tira de célula numérica. Vazio fica vazio.
export const cpfOnzeDigitos = (value: string) => {
  const digits = value.replace(/\D/g, "");
  return digits && digits.padStart(11, "0");
};

// Mesma regra de cpfValido (integracao_regras.go): 11 dígitos, não todos iguais, e os dois
// dígitos verificadores.
export const cpfValido = (d: string) => {
  if (!/^\d{11}$/.test(d) || /^(\d)\1{10}$/.test(d)) return false;
  const dv = (n: number) => {
    let soma = 0;
    for (let i = 0; i < n; i++) soma += Number(d[i]) * (n + 1 - i);
    const r = (soma * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return dv(9) === Number(d[9]) && dv(10) === Number(d[10]);
};
